/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{strict as a}from"../../core/jsonMap.js";const o=a()({RSP_NearestNeighbor:"nearest",RSP_BilinearInterpolation:"bilinear",RSP_CubicConvolution:"cubic",RSP_Majority:"majority"}),i=a()({esriNoDataMatchAny:"any",esriNoDataMatchAll:"all"});export{o as interpolationKebab,i as noDataInterpretationKebab};
